import Cookies from 'universal-cookie';
import { encrypt, decrypt } from './encryption-decryption';
const cookies = new Cookies();
let auth = {};

function loadAuthToken() {
  const encrypted = cookies.get('adminAuthToken');
  return encrypted ? decrypt(encrypted) : null;
}

function setAuthToken(authToken) {
  let domain = window.location.hostname;
  const encrypted = encrypt(authToken);

  cookies.set('adminAuthToken', encrypted, {
    path: '/',
    domain,
  });
}
function getAuthToken() {
  if (auth.token) return auth.token;

  const encrypted = cookies.get('adminAuthToken');
  if (!encrypted) return null;

  return decrypt(encrypted);
}

function getCompany() {
  const encrypted = cookies.get('company_id');
  return encrypted ? decrypt(encrypted) : null;
}

function resetAuthToken() {
  localStorage.clear();
  let domain = window.location.hostname;
  const host = window.location.hostname.split('.');
  if (host[0].indexOf('apps') >= 0) domain = `.${host[1]}.${host[2]}`;
  cookies.remove('Token', { path: '/', domain });
  cookies.remove('oAuthToken', { path: '/', domain });
  cookies.remove('company_id', { path: '/', domain });
  cookies.remove('shiftAuthToken', { path: '/', domain });
  cookies.remove('authToken', { path: '/' });
  cookies.remove('viewType', { path: '/' });
  auth.token = null;
  auth.company = null;
}

function getPageSizeAndNo(type) {
  if (type.indexOf('pageSize') > -1) {
    return cookies.get(type) ? parseInt(cookies.get(type)) : 20;
  } else if (type.indexOf('pageNo') > -1) {
    return cookies.get(type) ? parseInt(cookies.get(type))+1 : 1;
  }
}

function setCookies(type,value) {
    cookies.set(type,value,{ path: '/' })

}
export { loadAuthToken, setAuthToken, getAuthToken, resetAuthToken, getCompany, getPageSizeAndNo, setCookies};
